import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["element"];
import React from 'react';
import { StyledLinkActionPrimary, StyledLinkActionSecondary, StyledLinkPrimary, StyledLinkSecondary } from './Link.styled';
export var LinkPrimary = createLink(StyledLinkPrimary);
export var LinkSecondary = createLink(StyledLinkSecondary);
export var LinkActionPrimary = createLink(StyledLinkActionPrimary);
export var LinkActionSecondary = createLink(StyledLinkActionSecondary);
export var Link = {
  Primary: LinkPrimary,
  Secondary: LinkSecondary,
  /** `Link.Action` components look like buttons, but behave like links. */
  ActionPrimary: LinkActionPrimary,
  /** `Link.Action` components look like buttons, but behave like links. */
  ActionSecondary: LinkActionSecondary
};
function createLink(StyledLinkType) {
  var LinkComponent = function LinkComponent(_ref) {
    var _ref$element = _ref.element,
      element = _ref$element === void 0 ? 'a' : _ref$element,
      linkProps = _objectWithoutProperties(_ref, _excluded);
    var Component = StyledLinkType.withComponent(element);
    return /*#__PURE__*/React.createElement(Component, _extends({}, linkProps, {
      rel: linkProps.target === '_blank' ? 'noopener noreferrer' : undefined
    }));
  };
  return LinkComponent;
}